

























































































    import {Component, Vue} from "vue-property-decorator";
    import {Checkbox, Icon, Input, List, message, Tabs, Tooltip} from "ant-design-vue";
    import PersonalHeader from "@/components/Personal/PersonalHeader.vue";
    import reservationListTrashItem from "@/components/Personal/reservationList/reservationListTrashItem.vue";
    import {State} from "vuex-class";
    import {diagnosisTreat, medicalAppointmentListDeleted, RestoreMedicalAppointmentForm} from "@/services/api";

    Vue.use(Tabs);
Vue.use(Input);
Vue.use(List);
Vue.use(Icon);
Vue.use(Checkbox);
Vue.use(Tooltip);

@Component({
  components: {
    PersonalHeader,
    reservationListTrashItem
  }
})
export default class extends Vue {
  @State allReservationStatus;
  isAllCheck: Boolean = false;
  deleteModel: Boolean = false;
  serviceOrderInfoList: Array<any> = [];
  pagination = {
    total: 0,
    limit: 5,
    page: 1
  };
  data: any = [];
  created() {
    this.getList();
  }
  jumpAllyuyue(evt) {
    evt.preventDefault();
    this.$emit("jumpAllyuyue");
  }
  //获取回收站数据
  getList() {
    (this as any).data = [];
    diagnosisTreat({
      ...this.pagination,
      status: -1
    }).then(res => {
      let data = res.page;
      this.pagination.total = data.totalCount;
      data.list.forEach((el, i) => {
        (this as any).data.push({
          ischeck: false,
          id: i,
          ...el
        });
      });
      this.pagination.limit = data.pageSize;
    });
  }
  //跳转预约单界面
  chnabftab(e) {
    e.preventDefault();
    this.$emit("chnabftab");
  }
  //全选
  onChange(e) {
    this.isAllCheck = !this.isAllCheck;
    if (this.isAllCheck) {
      this.serviceOrderInfoList = [];
      (this as any).data.forEach(el => {
        el.ischeck = true;
        this.serviceOrderInfoList.push(el.telemedicineReservationId);
      });
    } else {
      let data = (this as any).data.filter(el => el.ischeck === true);
      if (data.length === this.data.length) {
        this.serviceOrderInfoList = [];
        (this as any).data.forEach(el => {
          el.ischeck = false;
        });
      }
    }
  }

  //单个数据选中
  getOrderInfoList(obj) {
    this.data[obj.id].ischeck = true;
    this.serviceOrderInfoList.push(obj.reservationId);
    if (this.serviceOrderInfoList.length == this.data.length) {
      this.isAllCheck = true;
    } else {
      this.isAllCheck = false;
    }
  }


  //单个数据取消选中
  deleteOrderInfoList(obj) {
    this.data[obj.id].ischeck = false;
    let newArr: any = [];
    for (let i = 0; i < this.serviceOrderInfoList.length; i++) {
      let newObj: any = JSON.parse(
        JSON.stringify(this.serviceOrderInfoList[i])
      );
      newArr.push(newObj);
    }
    for (let i = 0; i < newArr.length; i++) {
      if (newArr[i].reservationId === obj.reservationId) {
        newArr.splice(i, 1);
      }
    }
    this.serviceOrderInfoList = newArr;
    this.isAllCheck = false;
  }
  //单个数据删除提示
  singleDelete(id) {
    this.serviceOrderInfoList = [];
    this.serviceOrderInfoList.push(id);
    this.deleteByQueryEvent();
  }
  //单个还原
  singleHuanYuan(id) {
    this.serviceOrderInfoList = [];
    this.serviceOrderInfoList.push(id);
    this.huanyuanByQueryEvent();
  }
  //批量删除提示
  comfrimDelete() {
    this.deleteByQueryEvent();
    this.deleteModel = false;
  }
  //删除
  deleteByQueryEvent() {
    medicalAppointmentListDeleted(this.serviceOrderInfoList).then(res => {
      if (res.code === 0) {
        message.success("删除成功");
        this.serviceOrderInfoList = [];
        this.getList();
      } else {
        message.error("删除失败");
      }
      this.isAllCheck = false;
    });
  }
  //单个还原方法
  huanyuanByQueryEvent() {
    RestoreMedicalAppointmentForm(this.serviceOrderInfoList).then(res => {
      if (res.code === 0) {
        message.success("还原成功");
        this.serviceOrderInfoList = [];
        this.getList();
      } else {
        message.error("还原失败");
      }
      this.isAllCheck = false;
    });
  }

  huanyuanByQuery() {
    this.huanyuanByQueryEvent();
  }
  deleteByQuery() {
    this.deleteModel = true;
  }




  //分页数据
  onChangePageSize(page, pageSize) {
    window.scrollTo({top: 0});
    this.pagination.page = page;
    this.getList();
  }
}
